"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Cursors = Cursors;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
function Cursors({ as = 'div', spaceId: _spaceId, room, className, style, userCursorColor, children, renderCursor, propagate, zIndex, }) {
    const spaceId = _spaceId || `cursors-space-default--${String(room.type)}-${room.id}`;
    const cursorsPresence = room.usePresence({
        keys: [spaceId],
    });
    const fullPresence = room._core._reactor.getPresence(room.type, room.id);
    function publishCursor(rect, touch) {
        const x = touch.clientX;
        const y = touch.clientY;
        const xPercent = ((x - rect.left) / rect.width) * 100;
        const yPercent = ((y - rect.top) / rect.height) * 100;
        cursorsPresence.publishPresence({
            [spaceId]: {
                x,
                y,
                xPercent,
                yPercent,
                color: userCursorColor,
            },
        });
    }
    function onMouseMove(e) {
        if (!propagate) {
            e.stopPropagation();
        }
        const rect = e.currentTarget.getBoundingClientRect();
        publishCursor(rect, e);
    }
    function onMouseOut(e) {
        cursorsPresence.publishPresence({
            [spaceId]: undefined,
        });
    }
    function onTouchMove(e) {
        if (e.touches.length !== 1) {
            return;
        }
        const touch = e.touches[0];
        if (touch.target instanceof Element) {
            if (!propagate) {
                e.stopPropagation();
            }
            const rect = touch.target.getBoundingClientRect();
            publishCursor(rect, touch);
        }
    }
    function onTouchEnd(e) {
        cursorsPresence.publishPresence({
            [spaceId]: undefined,
        });
    }
    return (0, react_1.createElement)(as, {
        onMouseMove,
        onMouseOut,
        onTouchMove,
        onTouchEnd,
        className,
        style: Object.assign({ position: 'relative' }, style),
    }, [
        children,
        (0, jsx_runtime_1.jsx)("div", { style: Object.assign(Object.assign(Object.assign({}, absStyles), inertStyles), { zIndex: zIndex !== undefined ? zIndex : defaultZ }), children: Object.entries(cursorsPresence.peers).map(([id, presence]) => {
                const cursor = presence[spaceId];
                if (!cursor)
                    return null;
                return ((0, jsx_runtime_1.jsx)("div", { style: Object.assign(Object.assign({}, absStyles), { transform: `translate(${cursor.xPercent}%, ${cursor.yPercent}%)`, transformOrigin: '0 0', transition: 'transform 100ms' }), children: renderCursor ? (renderCursor({
                        color: cursor.color,
                        presence: fullPresence.peers[id],
                    })) : ((0, jsx_runtime_1.jsx)(Cursor, Object.assign({}, cursor))) }, id));
            }) }, spaceId),
    ]);
}
function Cursor({ color }) {
    const size = 35;
    const fill = color || 'black';
    return ((0, jsx_runtime_1.jsxs)("svg", { style: { height: size, width: size }, viewBox: `0 0 ${size} ${size}`, fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [(0, jsx_runtime_1.jsxs)("g", { fill: "rgba(0,0,0,.2)", transform: "matrix(1, 0, 0, 1, -11.999999046325684, -8.406899452209473)", children: [(0, jsx_runtime_1.jsx)("path", { d: "m12 24.4219v-16.015l11.591 11.619h-6.781l-.411.124z" }), (0, jsx_runtime_1.jsx)("path", { d: "m21.0845 25.0962-3.605 1.535-4.682-11.089 3.686-1.553z" })] }), (0, jsx_runtime_1.jsxs)("g", { fill: "white", transform: "matrix(1, 0, 0, 1, -11.999999046325684, -8.406899452209473)", children: [(0, jsx_runtime_1.jsx)("path", { d: "m12 24.4219v-16.015l11.591 11.619h-6.781l-.411.124z" }), (0, jsx_runtime_1.jsx)("path", { d: "m21.0845 25.0962-3.605 1.535-4.682-11.089 3.686-1.553z" })] }), (0, jsx_runtime_1.jsxs)("g", { fill: fill, transform: "matrix(1, 0, 0, 1, -11.999999046325684, -8.406899452209473)", children: [(0, jsx_runtime_1.jsx)("path", { d: "m19.751 24.4155-1.844.774-3.1-7.374 1.841-.775z" }), (0, jsx_runtime_1.jsx)("path", { d: "m13 10.814v11.188l2.969-2.866.428-.139h4.768z" })] })] }));
}
const absStyles = {
    position: 'absolute',
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
};
const inertStyles = {
    overflow: 'hidden',
    pointerEvents: 'none',
    userSelect: 'none',
};
const defaultZ = 99999;
//# sourceMappingURL=Cursors.js.map